// extracted by mini-css-extract-plugin
module.exports = {"header":"FilterAccordion-header-d584"};